import { createStore } from 'react-sweet-state';
import { cloneDeep } from 'lodash';

import {
  createModelScoringMethod,
  createTaxonomyScoringMethod,
  SCORING_METHOD_TYPE,
} from 'src/data/scoring';
import { queryCopyScoringModels } from 'src/graphql/copyScoringModel';
import { TABS } from '../const';

export const NAME = 'popup-scoring-method';

const INITIAL_STATE = {
  activeTab: TABS.anyword,

  selectedTaxonomyId: null,
  selectedModelId: '',
  isLoading: false,
  copyScoringModels: [],
  error: false,
};

export const PRIVATE_ACTIONS = {
  clearStore:
    () =>
    ({ setState }) => {
      setState(cloneDeep(INITIAL_STATE));
    },
};

/**
 * Publicly available actions
 */
export const ACTIONS = {
  initStore:
    () =>
    ({ dispatch }) => {
      dispatch(PRIVATE_ACTIONS.clearStore());
    },

  initSelection:
    (value) =>
    ({ setState }) => {
      if (!value) {
        return;
      }

      if (value.type === SCORING_METHOD_TYPE.contentTaxonomy) {
        setState({ selectedTaxonomyId: value.id, activeTab: TABS.anyword });
      } else if (value.type === SCORING_METHOD_TYPE.customModel) {
        setState({ selectedModelId: value.id, activeTab: TABS.custom });
      }
    },

  activateTab:
    (value) =>
    ({ setState }) => {
      setState({ activeTab: value, error: false });
    },

  selectTaxonomy:
    (taxonomyId) =>
    ({ setState }) => {
      setState({ selectedTaxonomyId: taxonomyId, error: false });
    },
  selectCustomModel:
    (modelId) =>
    ({ setState }) => {
      setState({ selectedModelId: modelId, error: false });
    },

  getScoringMethod:
    () =>
    ({ getState, setState }) => {
      const { activeTab, selectedTaxonomyId, selectedModelId, copyScoringModels } = getState();
      const scoringMethod =
        activeTab === TABS.anyword
          ? createTaxonomyScoringMethod(selectedTaxonomyId)
          : createModelScoringMethod(selectedModelId, copyScoringModels);
      const isValid = scoringMethod.id != null;

      if (isValid) return scoringMethod;

      setState({ error: true });
      return null;
    },
  queryCopyScoringModels:
    (generationTool) =>
    async ({ setState }, { currentCustomerId }) => {
      setState({ isLoading: true });

      try {
        const copyScoringModels = await queryCopyScoringModels({
          customerId: currentCustomerId,
          generationTool,
        });

        setState({ copyScoringModels });
      } finally {
        setState({ isLoading: false });
      }
    },
};

export const PopupStore = createStore({
  initialState: INITIAL_STATE,
  actions: ACTIONS,
  name: NAME,
});
